import { useCallback, useState } from "react";
import { Router } from "@reach/router";
import { ChakraProvider, createStandaloneToast } from "@chakra-ui/react";
import WordCloud from "./components/WordCloud/";
import ColumnChart from "./components/ColumnChart";
import Navbar from "./components/NavBar";
import Home from "./components/Home/";
import db from "./utils/indexedDb";
import BarChartRace from "./components/BarChartRace";

function App() {
  const [jsonObj, setJsonObj] = useState();

  const toast = createStandaloneToast();

  const onDrop = useCallback(
    (acceptedFiles) => {
      if (acceptedFiles.length > 1) {
        toast({
          title: "An error occurred.",
          description: "Max 1 .json-File supported",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
        return;
      }
      acceptedFiles.forEach(async (file) => {
        const reader = new FileReader();

        reader.onabort = () => {
          toast({
            title: "An error occurred.",
            description: "File reading was aboarded, please try again",
            status: "success",
            duration: 5000,
            isClosable: true,
          });
        };
        reader.onerror = () => {
          toast({
            title: "File reading has failed, please try again",
            status: "success",
            duration: 5000,
            isClosable: true,
          });
        };
        reader.onload = () => {
          const json = JSON.parse(reader.result);

          setJsonObj(json);

          db.jsonStorage
            .put({ id: 1, jsonObj: json })
            .then(() => {
              toast({
                title: "File successfully loaded",
                status: "success",
                duration: 5000,
                isClosable: true,
              });
            })
            .catch(() => {
              toast({
                title: "Couldn't save your file, please try again",
                status: "success",
                duration: 5000,
                isClosable: true,
              });
            });
        };
        reader.readAsText(file);
      });
    },
    [toast]
  );

  return (
    <ChakraProvider>
      <Navbar />
      <Router>
        <Home path="/" default onDrop={onDrop} />
        <WordCloud path="wordcloud" jsonObj={jsonObj} setJsonObj={setJsonObj} />
        <BarChartRace path="barchartrace" jsonObj={jsonObj} setJsonObj={setJsonObj} />
        <ColumnChart path="columnchart" jsonObj={jsonObj} setJsonObj={setJsonObj} />
      </Router>
    </ChakraProvider>
  );
}

export default App;
